import { newAPI } from '../newAxios';

export const leaveData = async (payload) => {
    const res = await newAPI.post('/leaves/employeeAll', payload);
    return res.data;
};

export const allLeavesData = async (pageSize, pageIndex, empId, start_date, end_date, approval_status) => {
    const res = await newAPI.post('/leaves', {
        pageSize,
        pageIndex,
        empId,
        start_date,
        end_date,
        approval_status
    });
    return res.data;
};

export const updateLeaveStatus = async (id, statusPayload) => {
    const res = await newAPI.patch(`/leaves/${id}`, statusPayload);
    return res.data;
};

export const singleLeaveData = async (id) => {
    const res = await newAPI.get(`/leaves/${id}`);
    return res.data[0];
};

export const addOrEditorApproveLeave = async (data) => {
    const result = await newAPI.post('leaves/add', data);
    return result;
};

export const leaveByAdmin = async (data) => {
    const result = await newAPI.post('leaves/addbyadmin', data);
    return result.data;
};

export const deleteLeaveData = async (id) => {
    const result = await newAPI.delete(`leaves/${id}`);
    return result;
};

export const employeeLeavesdata = async (id) => {
    const summaryRes = await newAPI.get(`/leaves/employeeId/${id}`);
    const leaveListRes = await newAPI.get(`/leaves/employeeAllId/${id}`);
    return {
        employeeLeaveSummary: summaryRes.data,
        employeeLeavesLsit: leaveListRes.data
    };
};

export const findTheOverLappingDates = async (data) => {
    const result = await newAPI.post('leaves/overLappingDates', data);
    return result.data;
};

export const findTheEmployeesleaveGroupBy = async (data) => {
    const result = await newAPI.post('leaves/employeesleaveGroupBy', data);
    return result.data;
};

export const employeeLeaveDropdownAPI = async () => {
    const result = await newAPI.get('leaves/dropdown-leave');
    return result.data;
};
